import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CalendarDays, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { usePrizeBadges } from "@/components/PrizeBadges";

export const OneToOneCheckout = () => {
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const prize = usePrizeBadges(!!user);
  const [hours, setHours] = useState(1);
  const [useHalf, setUseHalf] = useState(false);
  const [busy, setBusy] = useState(false);
  const pay = async () => {
    if (!user) { nav("/login", { state: { from: loc.pathname + loc.search } }); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/payments/one-to-one/checkout", { hours, use_half_price: useHalf, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Checkout failed");
      setBusy(false);
    }
  };
  const step = "flex h-8 w-8 items-center justify-center rounded-full border border-border text-lg hover:bg-secondary";
  return (
    <div className="w-full max-w-xs rounded-2xl border border-border bg-background p-5" data-testid="one-to-one-checkout-box">
      <div className="flex items-center justify-between">
        <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Hours</span>
        <div className="inline-flex items-center gap-2">
          <button onClick={() => setHours((h) => Math.max(1, h - 1))} data-testid="one-to-one-minus" className={step}>−</button>
          <span className="w-6 text-center font-serif text-xl" data-testid="one-to-one-hours">{hours}</span>
          <button onClick={() => setHours((h) => Math.min(10, h + 1))} data-testid="one-to-one-plus" className={step}>+</button>
        </div>
      </div>
      <div className="mt-4 flex items-baseline justify-between">
        <span className="text-sm text-muted-foreground">Total</span>
        <span className="font-serif text-2xl" data-testid="one-to-one-total">£{hours * 70 - (useHalf ? 35 : 0)}</span>
      </div>
      {prize?.half_price_available > 0 && (
        <label className="mt-3 flex items-center gap-2 rounded-xl bg-primary/10 p-3 text-sm" data-testid="one-to-one-half-price">
          <input type="checkbox" checked={useHalf} onChange={(e) => setUseHalf(e.target.checked)} data-testid="one-to-one-half-price-toggle" />
          Use my half-price hour (10 leaderboard badges) — save £35
        </label>
      )}
      <Button onClick={pay} disabled={busy} data-testid="one-to-one-checkout" className="mt-4 w-full rounded-full bg-primary py-6 text-base text-primary-foreground hover:bg-primary/90">
        {busy ? <Loader2 className="mr-2 animate-spin" size={18} /> : <CalendarDays className="mr-2" size={18} />}
        {user ? "Book & pay" : "Log in to book"}
      </Button>
    </div>
  );
};
